module.exports = __webpack_public_path__ + "img/hint_phone_back.43c27fab.png";